var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.images.length)?_c('div',{staticClass:"grid-x collapsed small-up-2 medium-up-3 large-up-4 gallery"},_vm._l((_vm.images),function(image){return _c('div',{key:image.id,staticClass:"cell"},[_c('a',{staticClass:"gallery-item",attrs:{"href":image.largeFileUrl}},[_c('img',{attrs:{"src":image.smallFileUrl,"alt":image.caption}})])])})):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-315d5882","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/src/components/Gallery/ImageGrid.vue
// module id = BquY
// module chunks = 1